import {
  streamLainAnimationController,
  type StreamLainAnimationHandle,
} from '@blocksuite/affine-shared/utils';

/** Visibility only; canvas coordinates and drag state remain with the watcher. */
export class EdgelessHandleMotion {
  private readonly states = new Map<
    HTMLElement,
    {
      visible: boolean;
      revision: symbol;
      handle?: StreamLainAnimationHandle;
    }
  >();

  sync(element: HTMLElement, visible: boolean, onHidden: () => void): void {
    const previous = this.states.get(element);
    if (previous?.visible === visible) return;
    const revision = Symbol('handle-motion');
    const computed =
      element.ownerDocument.defaultView!.getComputedStyle(element);
    const from = previous?.handle
      ? { opacity: computed.opacity, scale: computed.scale }
      : { opacity: visible ? 0 : 1, scale: visible ? '0.88' : '1' };
    const state = {
      visible,
      revision,
      handle: undefined as StreamLainAnimationHandle | undefined,
    };
    this.states.set(element, state);
    if (!previous && !visible) return;
    const handle = streamLainAnimationController.play(
      element,
      [from, { opacity: visible ? 1 : 0, scale: visible ? '1' : '0.88' }],
      visible ? 'enter' : 'exit'
    );
    state.handle = handle;
    void handle.finished.then(outcome => {
      if (this.states.get(element)?.revision !== revision) return;
      state.handle = undefined;
      if (outcome === 'finished' && !visible) onHidden();
    });
  }

  dispose(): void {
    for (const element of this.states.keys())
      streamLainAnimationController.cancel(element);
    this.states.clear();
  }
}
